import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const AutoScroll = () => {
  const { pathname } = useLocation();
  const refAutoScroll = useRef(null);

  useEffect(() => {
    if (refAutoScroll?.current && window.pageYOffset > 0) {
      refAutoScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [pathname, refAutoScroll]);

  return <div ref={refAutoScroll} />;
};

export default AutoScroll;
